<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <h2>{{ $t('RFM 用户明细') }}</h2>
      <a-form layout="inline" class="search-form">
        <a-form-item :label="$t('昵称')"><a-input v-model="queryParam.nickName" allow-clear :placeholder="$t('请输入昵称')" /></a-form-item>
        <a-form-item :label="$t('手机号')"><a-input v-model="queryParam.mobile" allow-clear :placeholder="$t('请输入手机号')" /></a-form-item>
        <a-form-item :label="$t('分群')">
          <a-select v-model="queryParam.rfmGroup" allow-clear style="width:160px">
            <a-select-option v-for="group in groupOptions" :key="group" :value="group">{{ group }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleQuery"><a-icon type="search" /> {{ $t('查询') }}</a-button>
          <a-button style="margin-left:8px" @click="resetQuery">{{ $t('重置') }}</a-button>
          <a-button v-hasPermi="['statistics:rfm:export']" style="margin-left:8px" @click="handleExport"><a-icon type="download" /> {{ $t('导出') }}</a-button>
        </a-form-item>
      </a-form>
      <a-table row-key="userId" :loading="loading" :columns="columns" :data-source="list" :pagination="false" />
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :total="total"
        :show-total="value => `${$t('共')}${value}${$t('条')}`"
        @change="changePage"
        @showSizeChange="changePage" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getRfmUserPage } from '@/api/statistics/order'

const groups = ['Champions', 'Loyal', 'Active', 'New', 'Promising', 'Needs attention', 'Almost lost', 'At risk', 'Previously loyal', 'Dormant']

export default {
  name: 'RfmDetail',
  data () {
    return {
      loading: false,
      list: [],
      total: 0,
      groupOptions: groups,
      queryParam: { nickName: undefined, mobile: undefined, rfmGroup: undefined, recencyRange: undefined, pageNum: 1, pageSize: 10 },
      columns: [
        { title: this.$t('用户ID'), dataIndex: 'userId' }, { title: this.$t('昵称'), dataIndex: 'nickName' },
        { title: this.$t('手机号'), dataIndex: 'mobile' }, { title: this.$t('评分分数'), dataIndex: 'rfmScore' },
        { title: this.$t('近7天购买次数'), dataIndex: 'sevenDayOrderCount' }, { title: this.$t('近7天花费'), dataIndex: 'sevenDayPayAmount' },
        { title: this.$t('分群'), dataIndex: 'rfmGroup' }
      ]
    }
  },
  created () {
    this.queryParam.rfmGroup = this.$route.query.rfmGroup || undefined
    this.queryParam.recencyRange = this.$route.query.recencyRange || undefined
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      getRfmUserPage(this.queryParam).then(response => {
        this.list = response.data.records || []
        this.total = Number(response.data.total || 0)
      }).finally(() => { this.loading = false })
    },
    handleQuery () { this.queryParam.pageNum = 1; this.getList() },
    resetQuery () {
      this.queryParam = { nickName: undefined, mobile: undefined, rfmGroup: undefined, recencyRange: undefined, pageNum: 1, pageSize: 10 }
      this.getList()
    },
    changePage (pageNum, pageSize) { this.queryParam.pageNum = pageNum; this.queryParam.pageSize = pageSize; this.getList() },
    handleExport () {
      this.download('statistics/order/rfm/user/export', { ...this.queryParam }, `${this.$t('RFM用户明细')}_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped>
.search-form { margin-bottom:16px; }
</style>
